import { ApiClient } from "@/api-client/src/core/api-client";

const apiClient = new ApiClient();
const webService = apiClient.web;
export interface CreateSiteSourcePayload {
  sourceName: string;
  sourceUrl: string;
  description?: string | null;
}

export const CreateSiteSource = async (data: CreateSiteSourcePayload) => {
  const response = await webService.post<CreateSiteSourcePayload>(
    "/site-source",
    data
  );
  return response;
};
